'use client';

import React, { useState } from 'react';
import Head from 'next/head';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const baseUrl = process.env.NEXT_PUBLIC_SITE_URL || 'http://localhost:3000';

const TV_APPEARANCES = [
{
  id: 'studio10',
  outlet: 'Studio 10',
  description:
  'Studio 10 is an Australian morning talk TV show on Network 10. The show is presented by Angela Bishop, Narelda Jacobs and Tristan MacManus.',
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_18aa8870e-1785151102244.png",
  logoAlt: 'Studio 10 logo',
  link: 'https://10play.com.au/studio-10',
  image:
  "https://images.unsplash.com/photo-1707592434705-672e9909b7e3",
  imageAlt: 'Anne and Renata on Studio 10 set',
  videos: [
  { title: 'Anne and Renata on Studio 10', url: 'https://www.youtube.com/watch?v=bRPxSAFXnzg' },
  { title: 'Studio 10 Investigation | Anne & Renata', url: 'https://www.youtube.com/watch?v=F-zej0DbU0M' }]

},
{
  id: 'kylejackieo',
  outlet: 'Kyle & Jackie O Show',
  description:
  "The Kyle & Jackie O Show is Australia\'s biggest radio show. Tune in weekday mornings from 6am on Sydney\'s KIIS 1065 and expect the unexpected.",
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1d5a8f1d3-1785151102908.png",
  logoAlt: 'KIIS 1065 logo',
  link: 'https://www.kiis1065.com.au/shows/kyle-jackie-o/',
  image:
  "https://images.unsplash.com/photo-1617233054577-5b3f42f1761e",
  imageAlt: 'Ghost hunting equipment used by Anne and Renata',
  videos: [
  {
    title: "Do Kyle & Jackie O live in a haunted house? What do ghost hunters Anne and Renata find?",
    url: 'https://www.youtube.com/watch?v=T8T0Aw0T5Ks'
  }]

},
{
  id: 'today',
  outlet: 'Today Show',
  description:
  'Today Show is an Australian breakfast TV news and current affairs program, with an infotainment base, hosted by Karl Stefanovic and Sarah Abo.',
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_104c8c717-1785151102293.png",
  logoAlt: 'Today Show logo',
  link: 'https://9now.nine.com.au/today',
  image: null,
  imageAlt: '',
  videos: [
  { title: 'Today Show Appearance | Anne and Renata', url: 'https://www.youtube.com/watch?v=5LCkfM9UnjY' }]

},
{
  id: 'sunrise',
  outlet: 'Weekend Sunrise',
  description:
  'Weekend Sunrise is an Australian breakfast television program, broadcast on the Seven Network and currently hosted by Monique Wright and Matt Doran.',
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1adc59c9d-1785151102269.png",
  logoAlt: 'Weekend Sunrise logo',
  link: 'https://7plus.com.au/weekend-sunrise',
  image: null,
  imageAlt: '',
  videos: [
  { title: 'Sunrise Appearance | Anne and Renata', url: 'https://www.youtube.com/watch?v=r1oN9G3g2hM' }]

},
{
  id: 'sydneyweekender',
  outlet: 'Sydney Weekender',
  description:
  'Sydney Weekender is an Australian travel TV show featuring destinations throughout the state of New South Wales.',
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_152d5faf1-1785151102682.png",
  logoAlt: 'Sydney Weekender logo',
  link: 'https://sydneyweekender.com.au',
  image:
  "https://img.rocket.new/generatedImages/rocket_gen_img_1cf7b2406-1785151103378.png",
  imageAlt: 'Anne and Renata at Maitland Gaol for Sydney Weekender',
  videos: [
  {
    title: 'Magnificent Maitland Gaol | Sydney Weekender Ft. Anne and Renata',
    url: 'https://www.youtube.com/watch?v=rVNgxrzw3z8'
  }]

}];


const NEWS_ARTICLES = [
{
  outlet: 'News.com.au',
  logo: 'https://images.squarespace-cdn.com/content/v1/5f851723cca8e53428f2c7d6/1603759926416-VXCAR4D775JFD2UL2Z94/1200px-News-com-au_logo.svg.png',
  logoAlt: 'News.com.au logo',
  headline: "The horrific detail about Jackie O's $11 million mansion.",
  url: 'https://www.news.com.au/entertainment/celebrity-life/the-horrific-detail-about-jackie-os-11-million-mansion/news-story/e25854138b737a4a61646e9024008dc5'
},
{
  outlet: 'Daily Mail Australia',
  logo: 'https://images.squarespace-cdn.com/content/v1/5f851723cca8e53428f2c7d6/1603759956912-SQRQPJEJ1W54Q2TJK62L/logo-dailymail_543x200-1.jpg',
  logoAlt: 'Daily Mail logo',
  headline:
  "Paranormal investigators CONFIRM Jackie \'O\' Henderson\'s $11 million mansion in Woollahra is haunted by a child ghost named Veronica.",
  url: 'https://www.dailymail.co.uk/tvshowbiz/article-8829585/Paranormal-investigators-confirm-Jackie-O-Hendersons-11-million-mansion-Woollahra-haunted.html'
},
{
  outlet: 'Yahoo! News',
  logo: 'https://images.squarespace-cdn.com/content/v1/5f851723cca8e53428f2c7d6/1603760007515-FXFK4VTNQN2GADUE70EB/Yahoo%21_News-Logo.wine.png',
  logoAlt: 'Yahoo News logo',
  headline: "Jackie O's confirms terrifying haunting at $11m Woollahra home.",
  url: 'https://au.news.yahoo.com/kyle-jackie-o-haunting-woolhara-home-ghosthunters-012337491.html'
},
{
  outlet: 'Daily Liberal',
  logo: 'https://images.squarespace-cdn.com/content/v1/5f851723cca8e53428f2c7d6/1603761219191-JQY9WBE30JIETYB4VO60/dailyliberal.png',
  logoAlt: 'Daily Liberal logo',
  headline: 'Ghost hunting 101 at the Old Dubbo Gaol.',
  url: 'https://www.dailyliberal.com.au/story/6649698/investigative-duo-to-lead-ghost-hunt-at-old-dubbo-gaol/'
},
{
  outlet: 'Cessnock Advertiser',
  logo: 'https://images.squarespace-cdn.com/content/v1/5f851723cca8e53428f2c7d6/1603762144493-1AELAGJLXKTM2IE1O3F1/the-advertiser.png',
  logoAlt: 'Cessnock Advertiser logo',
  headline:
  '"The Haunted Hunter: Ghosts, Urban Myths and True Encounters" presentation at Cessnock Library.',
  url: 'https://www.cessnockadvertiser.com.au/story/4674045/ghost-hunters-talk-at-library/'
},
{
  outlet: 'Maitland Mercury',
  logo: 'https://images.squarespace-cdn.com/content/v1/5f851723cca8e53428f2c7d6/1603762305571-NVUJWW2HO8O1PYEL963T/masthead-main.png',
  logoAlt: 'Maitland Mercury logo',
  headline:
  'Newcastle Ghost Tours reveal the after-dark secrets of the iconic Grossmann House.',
  url: 'https://www.maitlandmercury.com.au/story/6243186/what-goes-bump-in-the-dark/'
}];


const ISAAC_VIDEOS = [
{
  title: "Australia\'s Most Haunted Mine",
  url: 'https://www.youtube.com/watch?v=3hJGIw9Tx8s'
},
{
  title: 'Exploring A 200 Year Old Haunted Basement',
  url: 'https://www.youtube.com/watch?v=SGz9E-H7Fzc'
},
{
  title: "Locked in Satan's Cell (Haunted Prison)",
  url: 'https://www.youtube.com/watch?v=lDaa2IhO87k'
},
{
  title: 'Exploring The Most Haunted Street In Australia',
  url: 'https://www.youtube.com/watch?v=MuiFCO5cxUk'
}];


function YouTubeEmbed({ url, title }: {url: string;title: string;}) {
  const videoId = url.split('v=')[1]?.split('&')[0];
  return (
    <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
      <iframe
        className="absolute inset-0 w-full h-full rounded-lg"
        src={`https://www.youtube.com/embed/${videoId}`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{ border: '1px solid var(--border)' }} />
      
    </div>);

}

export default function MediaPage() {
  const [activeTab, setActiveTab] = useState<'tv' | 'radio' | 'news' | 'collabs'>('tv');

  const tabs = [
  { id: 'tv' as const, label: 'TV Appearances' },
  { id: 'radio' as const, label: 'Radio' },
  { id: 'news' as const, label: 'In the News' },
  { id: 'collabs' as const, label: 'Collaborations' }];


  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--background)', color: 'var(--foreground)' }}>
      <Head>
        <title>Media & Press — True Hauntings Podcast</title>
        <meta name="description" content="Anne and Renata have appeared on Studio 10, Kyle & Jackie O, Today Show, and major news outlets. View TV appearances, radio interviews, and press coverage." />
        <link rel="canonical" href={`${baseUrl}/media`} />
        <meta property="og:title" content="Media & Press Coverage" />
        <meta property="og:description" content="True Hauntings podcast featured on Australia's biggest TV shows and news outlets." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${baseUrl}/media`} />
      </Head>
      <Header />

      <main className="pt-24 pb-20">
        {/* Hero */}
        <section
          className="relative px-4 sm:px-6 lg:px-8 py-14 sm:py-20 overflow-hidden"
          style={{ background: 'linear-gradient(180deg, rgba(139,92,246,0.08) 0%, transparent 100%)' }}>
          
          <div
            className="absolute inset-0 opacity-20"
            style={{
              backgroundImage:
              'url(https://images.squarespace-cdn.com/content/v1/5f851723cca8e53428f2c7d6/c9d9bc0f-5009-4b0e-ae62-4639dac18660/20230201_211905.jpg)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              filter: 'blur(2px)'
            }} />
          
          <div className="relative max-w-3xl mx-auto text-center">
            <p
              className="text-xs font-mono tracking-widest uppercase mb-3"
              style={{ color: 'var(--primary)' }}>
              
              Press & Media
            </p>
            <h1
              className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-5"
              style={{ fontFamily: 'var(--font-display)' }}>
              
              In the Media
            </h1>
            <p className="text-sm sm:text-base leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
              Anne and Renata have appeared across Australia's biggest TV shows, radio programs, and news outlets — bringing paranormal investigation into the mainstream.
            </p>
          </div>
        </section>

        {/* Tab Nav */}
        <section className="px-4 sm:px-6 lg:px-8 py-6" style={{ borderBottom: '1px solid var(--border)' }}>
          <div className="max-w-6xl mx-auto">
            <div className="flex gap-1 overflow-x-auto pb-1">
              {tabs.map((tab) =>
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className="px-5 py-2.5 text-xs font-semibold tracking-widest uppercase whitespace-nowrap transition-colors rounded"
                style={{
                  fontFamily: 'var(--font-mono)',
                  color: activeTab === tab.id ? 'var(--background)' : 'var(--muted-foreground)',
                  backgroundColor: activeTab === tab.id ? 'var(--primary)' : 'transparent',
                  border: activeTab === tab.id ? 'none' : '1px solid var(--border)'
                }}>
                
                  {tab.label}
                </button>
              )}
            </div>
          </div>
        </section>

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">

          {/* TV Appearances */}
          {activeTab === 'tv' &&
          <div className="space-y-16">
              {TV_APPEARANCES.map((item) =>
            <div key={item.id} className="glass-card rounded-xl overflow-hidden">
                  <div className="p-6 sm:p-8">
                    {/* Outlet header */}
                    <div className="flex flex-col sm:flex-row sm:items-center gap-4 mb-6">
                      <div
                    className="flex items-center justify-center rounded-lg flex-shrink-0"
                    style={{ backgroundColor: '#ffffff', width: '200px', height: '200px' }}>
                    
                        <img
                      src={item.logo}
                      alt={item.logoAlt}
                      className="object-contain"
                      style={{ width: '200px', height: '200px' }} />
                    
                      </div>
                      <div>
                        <h2
                      className="text-xl sm:text-2xl font-bold mb-1"
                      style={{ fontFamily: 'var(--font-display)' }}>
                      
                          {item.outlet}
                        </h2>
                        <p className="text-sm leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
                          {item.description}
                        </p>
                        <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1 text-xs font-mono tracking-wider mt-2 transition-opacity hover:opacity-70"
                      style={{ color: 'var(--primary)' }}>
                      
                          Visit website →
                        </a>
                      </div>
                    </div>

                    {/* Videos */}
                    <div className="grid gap-6 grid-cols-1">
                      <div className={`space-y-4 ${item.videos.length > 1 ? 'grid sm:grid-cols-2 gap-4 space-y-0' : ''}`}>
                        {item.videos.map((video) =>
                    <div key={video.url}>
                            <p
                        className="text-xs font-mono tracking-wider mb-2 truncate"
                        style={{ color: 'var(--muted-foreground)' }}>
                        
                              {video.title}
                            </p>
                            <YouTubeEmbed url={video.url} title={video.title} />
                          </div>
                    )}
                      </div>
                    </div>
                  </div>
                </div>
            )}
            </div>
          }

          {/* Radio */}
          {activeTab === 'radio' &&
          <div className="glass-card rounded-xl overflow-hidden">
              <div className="p-6 sm:p-8">
                <div className="flex flex-col sm:flex-row sm:items-center gap-4 mb-8">
                  <div
                  className="flex items-center justify-center rounded-lg px-4 py-3 flex-shrink-0"
                  style={{ backgroundColor: '#ffffff', minWidth: '120px', maxWidth: '200px' }}>
                  
                    <img
                    src="https://images.squarespace-cdn.com/content/v1/5f851723cca8e53428f2c7d6/1647747534222-3ZWXLSIJG9MTJW01KA1H/newcastle-live-logo.png"
                    alt="Newcastle Live Radio logo"
                    className="h-10 object-contain"
                    style={{ maxWidth: '160px' }} />
                  
                  </div>
                  <div>
                    <h2
                    className="text-xl sm:text-2xl font-bold mb-1"
                    style={{ fontFamily: 'var(--font-display)' }}>
                    
                      Newcastle Live Radio
                    </h2>
                    <p className="text-sm leading-relaxed mb-2" style={{ color: 'var(--muted-foreground)' }}>
                      Tune into Anne &amp; Renata for <strong style={{ color: 'var(--foreground)' }}>Spooky Sundays</strong> on Newcastle Live Radio, every Sunday night{' '}
                      <strong style={{ color: 'var(--foreground)' }}>8:00 pm to 10:00 pm AEST</strong>.
                    </p>
                    <a
                    href="https://newcastlelive.com.au/spooky-sundays/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 text-xs font-mono tracking-wider transition-opacity hover:opacity-70"
                    style={{ color: 'var(--primary)' }}>
                    
                      Listen on Newcastle Live →
                    </a>
                  </div>
                </div>

                <div className="rounded-xl overflow-hidden" style={{ border: '1px solid var(--border)' }}>
                  <img
                  src="https://images.squarespace-cdn.com/content/v1/5f851723cca8e53428f2c7d6/5d915bf7-fff4-4470-91f1-fb6612aa4928/spooky-sunday-anne-and-renata.jpeg"
                  alt="Anne and Renata hosting Spooky Sundays on Newcastle Live Radio"
                  className="w-full object-contain"
                  style={{ maxHeight: '420px' }} />
                
                </div>

                <div
                className="mt-6 p-5 rounded-lg flex items-center gap-4"
                style={{ backgroundColor: 'rgba(139,92,246,0.08)', border: '1px solid rgba(139,92,246,0.2)' }}>
                
                  <span className="text-3xl">📻</span>
                  <div>
                    <p className="text-sm font-semibold mb-0.5" style={{ color: 'var(--foreground)' }}>
                      Spooky Sundays — Live Every Week
                    </p>
                    <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>
                      Every Sunday night · 8:00 pm – 10:00 pm AEST · Newcastle Live Radio
                    </p>
                  </div>
                </div>
              </div>
            </div>
          }

          {/* In the News */}
          {activeTab === 'news' &&
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {NEWS_ARTICLES.map((article) =>
            <a
              key={article.url}
              href={article.url}
              target="_blank"
              rel="noopener noreferrer"
              className="glass-card rounded-xl p-5 flex flex-col gap-4 group transition-all hover:scale-[1.02]"
              style={{ border: '1px solid var(--border)' }}>
              
                  <div
                className="flex items-center justify-center rounded-lg p-3"
                style={{ backgroundColor: '#ffffff', height: '60px' }}>
                
                    <img
                  src={article.logo}
                  alt={article.logoAlt}
                  className="h-7 object-contain"
                  style={{ maxWidth: '140px' }} />
                
                  </div>
                  <p className="text-sm leading-relaxed flex-1" style={{ color: 'var(--muted-foreground)' }}>
                    {article.headline}
                  </p>
                  <span
                className="text-xs font-mono tracking-wider group-hover:opacity-70 transition-opacity"
                style={{ color: 'var(--primary)' }}>
                
                    Read article →
                  </span>
                </a>
            )}
            </div>
          }

          {/* Collaborations */}
          {activeTab === 'collabs' &&
          <div className="space-y-10">
              <div className="flex flex-col sm:flex-row gap-6 items-start">
                <div
                className="rounded-xl overflow-hidden flex-shrink-0"
                style={{ border: '1px solid var(--border)', width: '100%', maxWidth: '260px' }}>
                
                  <img
                  src="https://images.squarespace-cdn.com/content/v1/5f851723cca8e53428f2c7d6/d31698a6-4973-4e66-a957-6469ee0f5277/isaac-butterfield.png"
                  alt="Isaac Butterfield comedian and content creator"
                  className="w-full object-contain"
                  style={{ height: '200px' }} />
                
                </div>
                <div>
                  <p className="text-xs font-mono tracking-widest uppercase mb-2" style={{ color: 'var(--primary)' }}>
                    Featured Collaboration
                  </p>
                  <h2 className="text-2xl sm:text-3xl font-bold mb-3" style={{ fontFamily: 'var(--font-display)' }}>
                    Isaac Butterfield Paranormal Documentaries
                  </h2>
                  <p className="text-sm leading-relaxed mb-3" style={{ color: 'var(--muted-foreground)' }}>
                    Anne and Renata feature in a series of documentaries by Australian comedian{' '}
                    <a
                    href="https://www.isaacbutterfield.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition-opacity hover:opacity-70"
                    style={{ color: 'var(--primary)' }}>
                    
                      Isaac Butterfield
                    </a>
                    . These documentaries have amassed over{' '}
                    <strong style={{ color: 'var(--foreground)' }}>1.2 million views</strong>.
                  </p>
                  <div
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-xs font-mono tracking-wider"
                  style={{ backgroundColor: 'rgba(139,92,246,0.12)', color: 'var(--primary)', border: '1px solid rgba(139,92,246,0.25)' }}>
                  
                    🎬 1.2M+ combined views
                  </div>
                </div>
              </div>

              <div className="grid sm:grid-cols-2 gap-6">
                {ISAAC_VIDEOS.map((video) =>
              <div key={video.url} className="glass-card rounded-xl p-4" style={{ border: '1px solid var(--border)' }}>
                    <p
                  className="text-xs font-mono tracking-wider mb-3 line-clamp-2"
                  style={{ color: 'var(--muted-foreground)' }}>
                  
                      {video.title}
                    </p>
                    <YouTubeEmbed url={video.url} title={video.title} />
                  </div>
              )}
              </div>
            </div>
          }
        </div>
      </main>

      <Footer />
    </div>);

}